import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function WithRouter({ component: Component, ...props }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const callableHistory = React.useMemo(() => {
    const historyFn = (to, options) => navigate(to, options);
    historyFn.push = (to, state) => navigate(to, { state });
    historyFn.replace = (to, state) => navigate(to, { replace: true, state });
    historyFn.goBack = () => navigate(-1);
    historyFn.goForward = () => navigate(1);
    historyFn.location = location;
    return historyFn;
  }, [navigate, location]);

  return <Component {...props} history={callableHistory} location={location} params={params} navigate={navigate} />;
}
